import { render, staticRenderFns } from "./videoContent.vue?vue&type=template&id=38656a3a&scoped=true&"
import script from "./videoContent.vue?vue&type=script&lang=js&"
export * from "./videoContent.vue?vue&type=script&lang=js&"
import style0 from "./videoContent.vue?vue&type=style&index=0&id=38656a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38656a3a",
  null
  
)

export default component.exports